import { render, staticRenderFns } from "./Activitydetail.vue?vue&type=template&id=78dd4dc9&scoped=true&"
import script from "./Activitydetail.vue?vue&type=script&lang=js&"
export * from "./Activitydetail.vue?vue&type=script&lang=js&"
import style0 from "./Activitydetail.vue?vue&type=style&index=0&id=78dd4dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dd4dc9",
  null
  
)

export default component.exports